import { render, staticRenderFns } from "./NoShiftMessage.vue?vue&type=template&id=82063658&scoped=true&"
import script from "./NoShiftMessage.vue?vue&type=script&lang=js&"
export * from "./NoShiftMessage.vue?vue&type=script&lang=js&"
import style0 from "./NoShiftMessage.vue?vue&type=style&index=0&id=82063658&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82063658",
  null
  
)

export default component.exports